import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { transition, trigger } from '@angular/animations';
import right from '../../shared/animations/right.animation';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import left from '../../shared/animations/left.animation';
import { ImportsModule } from '../../shared/imports.module';
import { PieDePaginaComponent } from '../../shared/components/pie-de-pagina/pie-de-pagina.component';
import { Router } from '@angular/router';
import { NzMenuModeType } from 'ng-zorro-antd/menu';
import up from '../../shared/animations/up.animation';
import down from '../../shared/animations/down.animation';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { MenusComponent } from "../../shared/components/menus/menus.component";
import { MsalService } from '@azure/msal-angular';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { PerfilStore } from '../../shared/store/perfil.store';
import { lastValueFrom, Subject } from 'rxjs';
import { Usuario } from '../../shared/models';
import { CatalogosService } from '../../shared/services/catalogos.service';
import { NzMessageContainerComponent } from "ng-zorro-antd/message";

import { HeadersStore } from '../../shared/store/headers.store';

@Component({
  selector: 'app-inicio',
  standalone: true,
  imports: [NzIconModule, RouterOutlet, ImportsModule, PieDePaginaComponent, CommonModule, MenusComponent, NzMessageContainerComponent],
  templateUrl: './inicio.component.html',
  styleUrl: './inicio.component.scss',
    animations: [
    trigger('shellRoutes', [
      transition(':increment', down(true)),
      transition(':decrement', up(true)),
    ]),
  ],
  providers: []
})
export class InicioComponent {
  animationState: number = 0;
  isBienvenida: boolean = true;
  collapsed: boolean = false;
  nzMenuMode: NzMenuModeType = 'vertical';
  isLoading : boolean = false;
  innerWidth: number | undefined;
  menuWidth: number = 80;
  user : Usuario | null = null;
  userAD : Usuario | null = null;
  $onDestroy: Subject<void> = new Subject<void>();
  notificaciones : any[] = [];
  periodo : any;
  constructor(
    private route: ActivatedRoute,   private cdr: ChangeDetectorRef, private router: Router, private authService: MsalService, private sessionStore: PerfilStore, private catalogos: CatalogosService,
  private headersStore: HeadersStore
  ){
      this.router.events.subscribe(() => {
        this.isBienvenida = this.router.url === '/home';
      });
    }
    ngOnInit() {
      this.getUser();
      this.obtenerPeriodo();
    }

  getUser(){
    this.sessionStore
      .getPerfil()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((user) => {
        this.user = user;
        if(!this.user){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.sessionStore.clearPerfil();
          this.router.navigate(['/']);
          this.cdr.detectChanges();
        }
      });
    this.sessionStore
      .getPerfilAD()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((userAD) => {
        this.userAD = userAD;
        if(!this.userAD){
          this.$onDestroy.next();
          this.$onDestroy.complete();
          this.cdr.detectChanges();
        }
      });
  }

  async obtenerPeriodo() {
    let response = await lastValueFrom(
      this.catalogos.obtenerCalendario()
    )
    this.periodo = response?.details || [];
    this.ObtenerNotificaciones();
  }


  ObtenerNotificaciones() {
    const fechaHoy = new Date();
    const mesActual = fechaHoy.getMonth() + 1;
    const periodos = this.periodo || [];
    if (periodos.length === 0) {
      return;
    }
    if (mesActual >= 2 && mesActual <= 12) {

    const fechaLimite = new Date(periodos.find((periodo:any) => 
        periodo.mesContable?.toLowerCase() === 'diciembre'
      )?.limiteInfoColaborador || '12/10/' + fechaHoy.getFullYear());
    if (fechaHoy > fechaLimite) {
      this.notificaciones.push(
        { 
          mensaje: 'El período de diciembre ha finalizado.',
          fecha: 'No se puede realizar solicitudes de reembolso y solicitudes de beneficio para gestantes'
        }
      );
      return;
    }
    const periodosFuturos = periodos.filter((periodo: any) => {
      if (!periodo.limiteInfoColaborador) return false;
      const fechaFin = new Date(periodo.limiteInfoColaborador);
      return fechaFin > fechaHoy;
    });
    if (periodosFuturos.length === 0) {
      return;
    }
    const periodoMasProximo = periodosFuturos.reduce((closest: any, current: any) => {
      const fechaFinCurrent = new Date(current.limiteInfoColaborador);
      const fechaFinClosest = new Date(closest.limiteInfoColaborador);
      return fechaFinCurrent < fechaFinClosest ? current : closest;
    });
    const fechaFin = new Date(periodoMasProximo.limiteInfoColaborador);
    const diferenciaTiempo = fechaFin.getTime() - fechaHoy.getTime();
    const diasRestantes = Math.ceil(diferenciaTiempo / (1000 * 3600 * 24));
    const mensaje = `El período de ${periodoMasProximo.mesContable} finaliza el ${fechaFin.toLocaleDateString('es-ES')}`;
    const fecha = `(${diasRestantes} días restantes)`
    this.notificaciones.push({ mensaje, fecha });

    }
    else {
      this.notificaciones.push(
        { 
          mensaje: 'El período Actual no es válido.',
          fecha: 'No se puede realizar solicitudes de reembolso y solicitudes de beneficio para gestantes'
        }
      );
    }
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }

  onActivate() {
    this.animationState = this.route.firstChild?.snapshot.data['routeIdx'];
    this.cdr.detectChanges();
  }


    logout() {
    localStorage.clear();
    this.authService.logoutRedirect();
  }

  closeSlider() {

  }

  isCollapsed = false;

  toggleCollapsed(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  getInitials(name: string | undefined): string {
    if (!name) return '';
    const names = name.split(' ');
    const initials = names.map(n => n.charAt(0).toUpperCase()).join('');
    return initials;
    }
  }